import { render, staticRenderFns } from "./AddMapItem.vue?vue&type=template&id=0bda08a4&scoped=true"
import script from "./AddMapItem.vue?vue&type=script&lang=js"
export * from "./AddMapItem.vue?vue&type=script&lang=js"
import style0 from "./AddMapItem.vue?vue&type=style&index=0&id=0bda08a4&prod&lang=scss&scoped=true"
import style1 from "./AddMapItem.vue?vue&type=style&index=1&id=0bda08a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bda08a4",
  null
  
)

export default component.exports